import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api';

// Async thunk to fetch stores for a given business_id
export const fetchStores = createAsyncThunk(
  'stores/fetchStores',
  async (business_id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/stores?business_id=${business_id}`);
      // re arrange thr data to be ascending order of each store name
      const sortedStores = response.data.sort((a, b) => a.name.localeCompare(b.name));
      return sortedStores;
    
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to add a new store
export const addStore = createAsyncThunk(
  'stores/addStore',
  async ({ business_id, name, latitude, longitude, google_review_url }, { rejectWithValue }) => {
    try {
      const response = await api.post('/stores', {
        business_id,
        name,
        latitude,
        longitude,
        google_review_url,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to update a store
export const updateStore = createAsyncThunk(
  'stores/updateStore',
  async ({ store_id, business_id, name, latitude, longitude, google_review_url }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/stores/${store_id}`, {
        business_id,
        name,
        latitude,
        longitude,
        google_review_url,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to delete a store
export const deleteStore = createAsyncThunk(
  'stores/deleteStore',
  async ({ store_id }, { rejectWithValue }) => {
    try {
      await api.delete(`/stores/${store_id}`);
      return store_id; // Return just the ID to remove it from state
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const storeSlice = createSlice({
  name: 'stores',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearStores: (state) => {
      state.items = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStores.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStores.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchStores.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addStore.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(addStore.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateStore.fulfilled, (state, action) => {
        const updatedStore = action.payload;
        const index = state.items.findIndex(store => store.store_id === updatedStore.store_id);
        if (index !== -1) {
          state.items[index] = updatedStore;
        }
      })
      .addCase(updateStore.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteStore.fulfilled, (state, action) => {
        state.items = state.items.filter(store => store.store_id !== action.payload);
      })
      .addCase(deleteStore.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearStores } = storeSlice.actions;

export default storeSlice.reducer;
